module.exports = __webpack_public_path__ + "static/img/toruviel.142b276.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/toruviel.png
// module id = YmRC
// module chunks = 0